export default "__VITE_ASSET__BWe9lEoI__"